<div
  role="button"
  tabindex="0"
  class="group flex cursor-pointer flex-col rounded-md border border-grey-concrete bg-white p-3 text-left text-xs shadow-sm transition-colors"
  [tooltip]="tooltip"
  [ngClass]="{
    'is-selected border-primary/60 bg-primary/10 ring-1 ring-primary': selected,
    'hover:bg-turquoise-light/5': !selected,
  }"
  (click)="selectGroup()"
  (keydown.enter)="selectGroup()"
  (keydown.space)="selectGroup()"
>
  <div class="flex items-start gap-2">
    <div
      class="flex size-8 shrink-0 items-center justify-center rounded"
      [ngClass]="group.attributes.group_entity_type === 'person' ? 'bg-turquoise-bright/15' : 'bg-blue-dark/15'"
    >
      <ion-icon
        [name]="group.attributes.group_entity_type === 'person' ? 'person-outline' : 'business-outline'"
        class="size-5 mt-0.5"
        [ngClass]="group.attributes.group_entity_type === 'person' ? 'text-turquoise-bright' : 'text-blue-dark'"
      ></ion-icon>
    </div>
    <div class="min-w-0 flex-1">
      <div class="font-medium text-sm">
        @for (segment of nameSegments; track $index) {
          @if (segment.highlight) {
            <mark
              class="relative isolate whitespace-nowrap rounded bg-transparent py-px text-black before:absolute before:-inset-1 before:-z-10 before:rounded before:bg-bright-yellow/40 before:transition-colors group-[.is-selected]:before:bg-transparent"
              >{{ segment.text }}</mark
            >
          } @else {
            <span>{{ segment.text }}</span>
          }
        }
      </div>
      <a
        class="btn-link font-normal text-[.9em]/none"
        [routerLink]="['/customers/edit/', group.attributes.id]"
        (click)="$event.stopPropagation()"
      >
        {{ group.attributes.id }}
      </a>
    </div>
    <div class="pt-0.5">
      <ion-checkbox mode="md" class="pointer-events-none" [checked]="selected"></ion-checkbox>
    </div>
  </div>

  <div class="grid md:grid-cols-2">
    @if (group.attributes.parent_group_id) {
      <div class="mt-3">
        <label class="p-0">Parent</label>
        <div class="mt-0.5">
          <app-group-display
            [groupId]="group.attributes.parent_group_id"
            [groupName]="group.attributes.parent_group_name || ''"
            [enableLink]="true"
          ></app-group-display>
        </div>
      </div>
    }
    <div class="mt-3 text-grey-mid">
      <label class="p-0">Email address</label>
      <div class="mt-0.5 break-words text-xs text-black font-medium">
        @for (segment of emailSegments; track $index) {
          @if (segment.highlight) {
            <mark
              class="relative isolate whitespace-nowrap rounded bg-bright-yellow/10 py-px text-black before:absolute before:-inset-1 before:-z-10 before:rounded before:bg-bright-yellow/40 before:transition-colors group-[.is-selected]:before:bg-bright-yellow/10"
              >{{ segment.text }}</mark
            >
          } @else {
            <span>{{ segment.text }}</span>
          }
        }
      </div>
    </div>
  </div>
</div>
